import { render, staticRenderFns } from "./headAccount.vue?vue&type=template&id=856b27da&scoped=true&"
import script from "./headAccount.vue?vue&type=script&lang=js&"
export * from "./headAccount.vue?vue&type=script&lang=js&"
import style0 from "./headAccount.vue?vue&type=style&index=0&id=856b27da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856b27da",
  null
  
)

export default component.exports